import {ActionIcon, Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import EditSvg from "../../../assets/v2-pencil.svg?react";
import CreateSvg from "../../../assets/v2-bold-plus.svg?react";
import FolderSvg from "../../../assets/v2-folder.svg?react";
import SettingsSvg from "../../../assets/v2-settings.svg?react";
import type {CollectionDataResponse} from "../types";
import styles from "./action-buttons.module.css";

type ActionButtonsProps = {
    collectionData?: CollectionDataResponse;
    setEditFillingOpen: (open: boolean) => void;
    setCreateFillingOpen: (open: boolean) => void;
    setOpenFillingOpen: (open: boolean) => void;
    setShareFillingOpen: (open: boolean) => void;
    setDuplicateFillingOpen: (open: boolean) => void;
    setDeleteFillingOpen: (open: boolean) => void;
};

export const ActionButtons = ({
    collectionData,
    setEditFillingOpen,
    setCreateFillingOpen,
    setOpenFillingOpen,
    setShareFillingOpen,
    setDuplicateFillingOpen,
    setDeleteFillingOpen,
}: ActionButtonsProps) => {
    const {t} = useTranslation();
    const isDraft = !collectionData?.metadata || collectionData.metadata.draft === 1;

    return (
        <div className={styles.fillingButtons}>
            {!isDraft ? (
                <ActionIcon
                    variant="subtle"
                    color="gray"
                    onClick={() => setEditFillingOpen(true)}
                    aria-label={t("Action.EditFilling")}
                    title={t("Action.EditFilling")}
                >
                    <EditSvg />
                </ActionIcon>
            ) : (
                <ActionIcon
                    variant="subtle"
                    color="gray"
                    onClick={() => setCreateFillingOpen(true)}
                    aria-label={t("Action.NewFilling")}
                    title={t("Action.NewFilling")}
                >
                    <CreateSvg />
                </ActionIcon>
            )}

            <ActionIcon
                variant="subtle"
                color="gray"
                onClick={() => setOpenFillingOpen(true)}
                aria-label={t("Action.OpenFilling")}
                title={t("Action.OpenFilling")}
            >
                <FolderSvg />
            </ActionIcon>

            {!isDraft && (
                <Menu position="bottom-end" withinPortal>
                    <Menu.Target>
                        <ActionIcon
                            variant="subtle"
                            color="gray"
                            aria-label={t("Action.OpenMenu")}
                            title={t("Action.OpenMenu")}
                        >
                            <SettingsSvg />
                        </ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Label>{t("Word.Filling")}</Menu.Label>
                        <Menu.Item onClick={() => setShareFillingOpen(true)}>
                            {t("common.share")}
                        </Menu.Item>
                        <Menu.Item
                            onClick={() => setDuplicateFillingOpen(true)}
                        >
                            {t("Word.Duplicate")}
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item onClick={() => setCreateFillingOpen(true)}>
                            {t("Word.New")}
                        </Menu.Item>
                        <Menu.Item
                            color="red"
                            onClick={() => setDeleteFillingOpen(true)}
                        >
                            {t("common.delete")}
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
            )}
        </div>
    );
};
